import { render, staticRenderFns } from "./oneRecord.vue?vue&type=template&id=c7c93386&"
import script from "./oneRecord.vue?vue&type=script&lang=js&"
export * from "./oneRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports